
<script>
import BarList from '../components/bar-list'
import ConfigFormLoja from './config-form-loja'
import { apiORDSpost } from '../shared/api-functions'
import { SysVars } from '../main';
import { isValidURLSubdomain } from '../shared/utils'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            usuario: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',


            errmessages: [],

            url: '',

            invalidSub: false,
        }
    },

    computed: {
        filialList: function () {
            return this.$store.getters.getFilialList
        },

        dominio: function () {
            return this.$store.getters.getSessao.dominio
        },

        sufixoDominio: function () {
            if (typeof window !== 'undefined' && window.location && window.location.host) {
                if (window.location.host.indexOf('teste') >= 0 || window.location.host.indexOf('localhost') >= 0) {
                    return '.teste.notabrasil.com.br'
                }
            }
            return '.notabrasil.com.br'
        },

        urlLojaCompleta: function () {
            return 'https://' + this.dominio + this.sufixoDominio + '/loja'
        },
    },

    filters: {

    },

    methods: {
        loadData () {
                this.$store.dispatch('loadFilial', {})
        },

        handleSalvar () {

            this.url = this.url.replace('.teste.notabrasil.com.br', '')
            this.url = this.url.replace('.notabrasil.com.br', '')

            this.url = this.$removerAcentos(this.url.toLowerCase())
            //console.log(isValidURLSubdomain(this.url))
            //console.log(this.url)

            this.invalidSub = !isValidURLSubdomain(this.url)

            if (this.invalidSub) {
                return
            }
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        async apiPost (pDelete) {
            var sendData = { dominio: this.url, deletar: 'N'};
            if (pDelete){
                sendData = { dominio: this.dominio, deletar: 'S'};
            }
            const data = await apiORDSpost(this.$store, 'loja/dominio/', sendData, 'post')

            if (data) {
                if (data.errmessages) {
                    this.errmessages = data.errmessages
                } else {

                    this.errmessages = {}
                }
            }
            this.$store.dispatch('loadSessao', this)
        },


        handleDeletar () {
            this.apiPost(true)
        },

         handleWhatsApp(opc) {

          if (this.dominio != null) {
           var msg = "";
           var enderecoURL = "";

           switch (opc) {
               case 1: // Destaques
                   enderecoURL = this.urlLojaCompleta + "/#/destaques"
                   break;
               case 2: // Promoções
                   enderecoURL = this.urlLojaCompleta + "/#/promocoes"
                   break;
               default:
                   enderecoURL = this.urlLojaCompleta
                   break;
           }

           msg = "🛍 *Acesse nossa loja *" + enderecoURL;

            msg = window.encodeURIComponent(msg);

            window.open("https://wa.me/?text=" + msg, "_blank");
          }
        },


    },

    watch: {
        url: function () {
            if (this.url) {
                this.url = this.url.replace(' ', '-')
            }
        }
    },

    components: {
        ConfigFormLoja
    },

    created () {
        this.loadData()
    }

}

</script>

<template>

<div id="list">


    <div class="default-container mb-2 p-5" v-if="!dominio">
        <label-title class="" title="Configuração Inicial" icon="fa-shopping-basket"></label-title>
        <div class="row">
            <div class="col-md-6 col-10 mb-2">
                <span class="">Informe nome de domínio para sua loja</span>
                <!-- <v-label class="" label="Informe nome de domínio para sua loja" :title="'Informe o nome que seus clientes irão utilizar para acessar sua loja virtual, exemplo: nome-da-sua-loja.notabrasil.com.br'"></v-label> -->
                <!-- <span class="lbl-list">Informe o nome que seus clientes irão utilizar para acessar sua loja virtual, exemplo: nome-da-sua-loja.notabrasil.com.br</span> -->
            </div>
            <div class="w-100"></div>
            <form-field v-model="url" type="text" col="6" case="lower"
                name="url" :v-errors="errors" v-validate="{max: 100}" :placeholder="'nome-da-sua-loja' + sufixoDominio">
                <span class="lbl-list">Informe o nome que seus clientes irão utilizar para acessar sua loja virtual, exemplo: nome-da-sua-loja{{ sufixoDominio }}</span>
                <span class="lbl-list">Informe apenas letras, numeros e hífen "-"</span><br>
                <span v-if="invalidSub" class="error">Nome de domínio inválido. Use apenas letras, números e "-"</span>
            </form-field>
            <div class="w-100"></div>
            <div class="col-12" v-if="errmessages.length > 0">
                <alert type="error" :close="false" title="Erro" :messages="errmessages"></alert>
            </div>
            <div v-else class="col-md-6 col-10">
                <span v-if="url" class="mt-3 badge badge-secondary" style="font-size: 24px">https://{{ url }}{{ sufixoDominio }}/loja</span>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 col-10">
                <v-button label="Confirmar" icon="fa-check" @click="handleSalvar"></v-button>
            </div>
        </div>
    </div>


    <div class="default-container d-flex justify-content-between align-items-center py-4 mb-2" v-if="dominio">
        <div>
            <label-title class="" title="Link de Acesso" icon="fa-shopping-basket"></label-title>
            <div class="row">
                <div class="col-md-4 col-12">
                    <span class="badge badge-secondary" style="font-size: 18px;"><a style="color: white" :href="urlLojaCompleta" target="_blank">{{ urlLojaCompleta }}</a></span>
                </div>
                <div class="w-100">
                </div>
                <!-- <div class="col-md-2 col-12">
                    <span class="py-2" style="cursor: pointer" @click="handleWhatsApp(1)"><i class="fa d-inline fa-whatsapp "></i> Destaques</span>
                </div> -->
                <div class="col-12" v-if="errmessages.length > 0">
                    <alert type="error" :close="false" title="Erro" :messages="errmessages"></alert>
                </div>

            </div>
        </div>

        <v-button label="Alterar Link de Acesso" icon="fa-trash" @click="handleDeletar"></v-button>

    </div>


    <div class="default-container py-4" v-if="dominio">
        <div class="row" v-for="(filial, index) in filialList" :key="index">
            <div class="col-12">
                <span class="lbl-deal-title">CONFIGURAÇÕES DA EMPRESA</span>

                <label-title class="" :title="filial.nome" icon="fa-building"></label-title>
            </div>
            <div class="col-12 p-3">
                <config-form-loja :codfil="filial.codfil"></config-form-loja>
            </div>
        </div>
    </div>


</div>

</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-loja/config-list-loja.vue